import { AppRouteGroup } from 'utils/routing/AppRouteGroup';

import {
  GRAD_PROGRAM_URL_SEGMENTS,
  INTERNSHIP_URL_SEGMENTS,
  INTERNSHIP_URL_SEGMENTS_BY_LOCALE,
  JOB_URL_SEGMENTS,
  JOB_URL_SEGMENTS_BY_LOCALE,
  ORG_TYPE_URL_SEGMENTS,
  VOLOP_URL_SEGMENTS,
  VOLOP_URL_SEGMENTS_BY_LOCALE,
  combinedOrgTypeAndInternshipUrlSegments,
  combinedOrgTypeAndJobUrlSegments,
} from './mainRouteSegments';

export const mainRouteGroup = new AppRouteGroup({
  path: '/:lang',
  params: ['lang'],
});

export const mainHomeRoute = mainRouteGroup.route({ path: '' });

// Org

export const mainOrgSegmentedRoutes = ORG_TYPE_URL_SEGMENTS.flatMap(
  (orgTypeUrlSegment) => [
    mainRouteGroup.route({
      path: `${orgTypeUrlSegment}/:orgIdDashSlug`,
      params: ['orgIdDashSlug'],
    }),
    mainRouteGroup.route({
      path: `amp/${orgTypeUrlSegment}/:orgIdDashSlug`,
      params: ['orgIdDashSlug'],
    }),
  ],
);

// Jobs

export const mainJobSegmentedRoutes = [
  ...JOB_URL_SEGMENTS,
  ...combinedOrgTypeAndJobUrlSegments,
].flatMap((jobUrlSegment) => [
  mainRouteGroup.route({
    path: `${jobUrlSegment}/:jobIdDashSlug`,
    params: ['jobIdDashSlug'],
  }),
  mainRouteGroup.route({
    path: `amp/${jobUrlSegment}/:jobIdDashSlug`,
    params: ['jobIdDashSlug'],
  }),
]);

const mainJobsRouteReference = mainRouteGroup.route({
  path: ':segment',
  params: ['segment'],
  searchParams: ['q'],
});

export function getMainJobsRoutePath(data: { lang: UserLocale; q: string }) {
  const { lang, q } = data;
  const segment = JOB_URL_SEGMENTS_BY_LOCALE[lang];

  return mainJobsRouteReference.with({ lang, segment, q });
}

// Internship

export const mainInternshipSegmentedRoutes = [
  ...Object.values(INTERNSHIP_URL_SEGMENTS),
  ...combinedOrgTypeAndInternshipUrlSegments,
].flatMap((internshipUrlSegment) => [
  mainRouteGroup.route({
    path: `${internshipUrlSegment}/:internshipIdDashSlug`,
    params: ['internshipIdDashSlug'],
  }),
  mainRouteGroup.route({
    path: `amp/${internshipUrlSegment}/:internshipIdDashSlug`,
    params: ['internshipIdDashSlug'],
  }),
]);

const mainInternshipsRouteReference = mainRouteGroup.route({
  path: ':segment',
  params: ['segment'],
  searchParams: ['q'],
});

export function getMainInternshipsRoutePath(data: {
  lang: UserLocale;
  q: string;
}) {
  const { lang, q } = data;
  const segment = INTERNSHIP_URL_SEGMENTS_BY_LOCALE[lang];

  return mainInternshipsRouteReference.with({ lang, segment, q });
}

// Volop

export const mainVolopSegmentedRoutes = VOLOP_URL_SEGMENTS.flatMap(
  (volopUrlSegment) => [
    mainRouteGroup.route({
      path: `${volopUrlSegment}/:volopIdDashSlug`,
      params: ['volopIdDashSlug'],
    }),
    mainRouteGroup.route({
      path: `amp/${volopUrlSegment}/:volopIdDashSlug`,
      params: ['volopIdDashSlug'],
    }),
  ],
);

const mainVolopsRouteReference = mainRouteGroup.route({
  path: ':segment',
  params: ['segment'],
  searchParams: ['q'],
});

export function getMainVolopsRoutePath(data: { lang: UserLocale; q: string }) {
  const { lang, q } = data;
  const segment = VOLOP_URL_SEGMENTS_BY_LOCALE[lang];

  return mainVolopsRouteReference.with({ lang, segment, q });
}

// Grad Program

export const mainGradProgramSegmentedRoutes = GRAD_PROGRAM_URL_SEGMENTS.flatMap(
  (gradProgramUrlSegment) => [
    mainRouteGroup.route({
      path: `${gradProgramUrlSegment}/:programIdDashSlug`,
      params: ['programIdDashSlug'],
    }),
    mainRouteGroup.route({
      path: `amp/${gradProgramUrlSegment}/:programIdDashSlug`,
      params: ['programIdDashSlug'],
    }),
  ],
);
